import {
  Editor,
  Transforms
} from 'slate';

import elementTypes from '../../elements/types';

import HelptapEditor from '../';

import * as baseNodeUtilities from './base-node';

export function getDefaultOptions() {

  const options = {
    ...baseNodeUtilities.getDefaultOptions(),
    options: {
      memberId: null,
      id: Math.random().toString().split('.').pop()
    },
    properties: {}
  };

  return options;

}

export function select(editor, path) {

  Transforms.select(editor, path);

}

function doInsert(editor, options, path) {

  const node = {
    ...getDefaultOptions(),
    type: elementTypes.MEMBER_CALENDAR
  };

  node.options.memberId = options.options.memberId;

  Transforms.insertNodes(editor, node, {
    at: path
  });

  select(editor, path);

}

export function insert(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Editor.withoutNormalizing(editor, () => {

    doInsert(editor, options, nextNodePath);

  });

}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Editor.withoutNormalizing(editor, () => {

    doInsert(editor, options, targetNodePath);
    Transforms.removeNodes(editor, {
      at: nextNodePath
    });

  });

}

export function cloneNode(node) {

  const clonedNode = {
    ...node,
    options: {
      ...(node.options || {
        memberId: null,
        id: Math.random().toString().split('.').pop()
      })
    }
  };

  return clonedNode;

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = cloneNode(HelptapEditor.cloneNode(node));

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}